import { makeHttpRequest } from "@/shared";

import {
    mapTariffFromServer,
    mapTariffsListFromServer,
} from "./mappers/mapTariffsListFromServer";

export const getTariffsList = async (promocode) => {
    const response = (
        await makeHttpRequest({
            url: "/tariff/list",
            method: "GET",
            params: { promocode },
        })
    ).data;

    // Бесплатный тариф сервер отдаёт отдельно: он не покупается
    return {
        tariffs: mapTariffsListFromServer(response.data),
        freeTariff: response.free ? mapTariffFromServer(response.free) : null,
    };
};
